import clsx from 'clsx';
import { LandingPageContent } from './landing-page-content';
// import {Navbar} from '@common/ui/navigation/navbar/navbar';
// import {Button, ButtonProps} from '@ui/buttons/button';
import { IconButton } from '@ui/buttons/icon-button';
import { KeyboardArrowDownIcon } from '@ui/icons/material/KeyboardArrowDown';
// import {Footer} from '@common/ui/footer/footer';
import { Trans } from '@ui/i18n/trans';
import { AdHost } from '@common/admin/ads/ad-host';
// import {Link} from 'react-router-dom';
import { createSvgIconFromTree } from '@ui/icons/create-svg-icon';
import { MenuItemConfig } from '@common/menus/menu-config';
import { Fragment, useEffect, useState } from 'react';
import { DefaultMetaTags } from '@common/seo/default-meta-tags';
import { useTrans } from '@ui/i18n/use-trans';
import { useSettings } from '@ui/settings/use-settings';
import { MixedImage } from '@ui/images/mixed-image';
import companyLogo from './images/company-logo.png';
import heroBg from './images/BG-DNcWQDN9.png';
import heroImgLg from './images/Mockup shadow-59lZxPa7.png';
import heroImgSm from './images/Mockup shadow Mobile-B9s5EjEw.png';
import logos from './images/Logos-B1S2Pc1A.png';
import shareImg from './images/feat1-fNkW-c-2.png';
import chartImg from './images/feat2-D2ozoEcv.png';
import lineImg from './images/feat3-Bjz4KxBl.png';
import React from "react";
import { Navbar, NavbarBrand, NavbarContent, NavbarItem, NavbarMenuToggle, NavbarMenu, NavbarMenuItem, Button, NextUIProvider } from "@nextui-org/react";
import PlansCard from '@app/PlansCard';
import { apiClient } from '@common/http/query-client';
import { useNavigate } from '@common/ui/navigation/use-navigate';
import { PricingTable } from '@common/billing/pricing-table/pricing-table';
import { UpsellBillingCycle } from '@common/billing/pricing-table/find-best-price';
import { Link, NavLink, useLocation } from 'react-router-dom';
import Scale from './icons/Scale';
import RealTime from './icons/RealTime';
import Secure from './icons/Secure';
import VersionHistory from './icons/VersionHistory';
import Integration from './icons/Integration';
import PricingModels from './icons/PricingModels';

interface ContentProps {
  content: LandingPageContent;
}
export function LandingPage() {
  const settings = useSettings();
  const homepage = settings.homepage as { appearance: LandingPageContent };

const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        const offset = 100;
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
      }
    }
  }, [location]);


  return (
    <Fragment>
      <NextUIProvider>
        <DefaultMetaTags />
        <div>
          <Nav />
          <HeroHeader />
          <Features />
          <Solutions />
          <Pricing />
          <Footer />
          {/* <AdHost slot="landing-top" className="mb-14 px-14 md:mb-60" />
          <PrimaryFeatures content={homepage.appearance} />
          <div className="my-40 h-1 bg-divider" />
          <SecondaryFeatures content={homepage.appearance} />
          <BottomCta content={homepage.appearance} />
          <Footer className="landing-container" /> */}
        </div>
      </NextUIProvider>
    </Fragment>
  );
}


export const Footer = () => {
  return (
    <footer className="py-40 bg-white dark:bg-transparent dark:border-t">
      <div className="px-10 md:px-24 mx-auto text-center flex justify-between items-center">
        <ul className="flex justify-center space-x-16">
          <li>
            <Link
              to={"/pages/privacy-policy"}
              className="text-gray-600 hover:text-black dark:hover:text-white transition"
            >
              <Trans message='Privacy Policy'/>
            </Link>
          </li>
          <li>
            <Link
              to="/pages/terms-of-service"
              className="text-gray-600 hover:text-black dark:hover:text-white transition"
            >
              <Trans message='Terms of Service'/>
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              className="text-gray-600 hover:text-black dark:hover:text-white transition"
            >
              <Trans message='Contact us'/>
            </Link>
          </li>
        </ul>
        <ul className='flex justify-center space-x-16 text-lg'>
          <li><a target='_blank' href="https://www.facebook.com/CandyCloudy.CloudStorage"><i className='fa-brands fa-facebook-f'></i></a></li>
          <li><a target='_blank' href="https://www.instagram.com/candycloudy.cloudstorage/"><i className='fa-brands fa-instagram'></i></a></li>
          <li><a target='_blank' href="https://ae.linkedin.com/in/candycloudy"><i className='fa-brands fa-linkedin-in'></i></a></li>
          <li><a target='_blank' href="https://x.com/candycloudy2025"><i className='fa-brands fa-x-twitter'></i></a></li>
        </ul>
      </div>
      <div className='container pt-16 text-gray-600 text-center'>
        <p>© {new Date().getFullYear()} Candy Cloudy. All rights reserved. Website developed by <Link to={"https://solidedgesolutions.net/"} target='_blank' className='text-primary'>SES</Link>.</p>
        {/* <p className=''>Website developed by <Link to={"https://wa.me/201116322237"} target='_blank' className='text-theme'>SES</Link>.</p> */}
      </div>
    </footer>
  );
};

function HeroHeader() {
  return (
    <>

      <header className='hero-bg min-h-screen flex w-full items-center justify-center'>
        <div className='container'>
          <div className='flex justify-center items-center flex-col pt-50 md:p-[50px] pb-0'>
            <h1 className='font-[600] text-[48px] md:text-[90px] text-center max-w-[974px] leading-[48px] md:leading-[108px] text-[#222E57] dark:text-white'><Trans message="Effortless Cloud"/> <span className='text-gradient-pink'><Trans message="Storage"/></span> <Trans message="for Your Business"/></h1>
            <p className='max-w-[974px] text-[18px] text-[#888888] text-center mt-32 font-[300] md:font-[400]'><Trans message='Whether you need a quick solution or have specific processes that need to be optimised,we are your partner to implement Odoo solutions.' /></p>
          </div>
          <form className='mt-48 md:mt-0 mb-50 px-20 flex flex-wrap w-full items-center justify-center gap-8'>
            <input type="email" placeholder='enter your email here' name='freeTrialEmail' id='freeTrialEmail' className='text-black dark:text-white bg-[#EAEBF0] w-full md:w-[353px] h-[48px] py-8 px-24 rounded-[12px] border' />
            <button className='text-white w-full md:w-[159px] h-[48px] rounded-[12px] bg-primary text-[16px] font-[500]'><Trans message="Start Free Trial"/></button>
          </form>
          <img src={heroImgLg} className='max-w-[1000px] hidden lg:block mx-auto' loading='lazy' alt="candy cloudy website drive page" />
          <img src={heroImgSm} className='block lg:hidden mx-auto' loading='lazy' alt="candy cloudy website drive page" />
          <div className='py-40 lg:px-80'>
            <div className="overflow-x-hidden w-full ant-flex css-pvzb04 ant-flex-justify-center">
              <img src={logos} className="h-[30px] !w-[1308px] partener-anim white-filter" alt="Partners" />
              <img src={logos} className="h-[30px] !w-[1308px] partener-anim white-filter" alt="Partners" />
              <img src={logos} className="h-[30px] !w-[1308px] partener-anim white-filter" alt="Partners" />
            </div>
          </div>

        </div>
      </header>
    </>
  );
}

function Features() {

  const data: FeatureCardInterface[] = [
    { icon: <Scale />, title: 'Scalable Storage Solutions', desc: 'Upgrade your plan as your needs grow effortlessly.' },
    { icon: <RealTime />, title: 'Real-Time Collaboration', desc: 'Work simultaneously with your team, no matter where they are.' },
    { icon: <Secure />, title: 'Secure Storage with Top Encryption', desc: 'Your data is safe with enterprise-grade encryption protocols.' },
    { icon: <VersionHistory />, title: 'Version History & Rollback', desc: 'Easily track changes and revert to older file versions.' },
    { icon: <Integration />, title: 'Seamless Integrations', desc: 'Connect with tools like Slack, Microsoft Teams, and more.' },
    { icon: <PricingModels />, title: 'Flexible Pricing Models', desc: 'Pay only for what you use with transparent pricing.' },
  ]

  return (
    <div className='py-80 px-20 lg:px-80 flex flex-col w-full items-center'>
      <h1 className='text-[#24336A] dark:text-white font-[600] text-3xl md:text-[56px] md:leading-[67.2px] text-center max-w-[764px]'><span className="text-gradient-pink"><Trans message="Packed"/></span> <Trans message="with Sweet Features"/>.</h1>
      <h3 className="text-[#888888] mt-32 text-center text-lg max-w-[764px]"><Trans message="From seamless collaboration to scalable storage solutions, Candy Cloudy simplifies your cloud experience."/></h3>
      <div className='w-full flex flex-wrap gap-y-64 mt-64 items-stretch'>
        {data.map(card => {
          return (
            <div key={card.title} className='md:px-64 lg:w-1/3 md:w-1/2 w-full flex justify-center'>
              <FeatureCard {...card} key={card.title}></FeatureCard>
            </div>
          )
        })}
      </div>
    </div>
  )
}

interface FeatureCardInterface {
  icon: React.ReactNode;
  title: string;
  desc: string
}

function FeatureCard({ desc, icon, title }: FeatureCardInterface) {
  return (
    <div className='w-full h-full flex flex-col items-center justify-between'>
      {icon}
      <h3 className='text-xl text-center font-semibold text-[#222E57] mt-20'><Trans message={title}/></h3>
      <h4 className='mt-8 text-[#888888] text-center max-w-[384px]'><Trans message={desc}/></h4>
    </div>
  )
}

export function Nav() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const navigate = useNavigate();

  // Function to update the scroll position
  const handleScroll = () => {
    const position = window.scrollY;
    setScrollPosition(position);
  };

  // useEffect to attach the event listener
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  return (
    <Navbar isMenuOpen={isMenuOpen} onMenuOpenChange={setIsMenuOpen} className={`lg:py-10 delay-200 duration-200 ${scrollPosition === 0 ? 'hero-bg' : 'bg-white dark:bg shadow-md'}`}>
      <NavbarContent justify='start'>
        <NavbarBrand className=''>
          <Link to={'/'}>
            <img src={companyLogo} width={70} alt="" />
          </Link>
        </NavbarBrand>

      </NavbarContent>
      <NavbarContent justify='end' className='lg:hidden flex'>
        <NavbarMenuToggle
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          className="lg:hidden me-5"
          icon={() => {
            if (!isMenuOpen)
              return <i className='fa-solid fa-bars'></i>;
            else
              return <i className='fa-solid fa-x'></i>
          }}
        />
      </NavbarContent>

      <NavbarContent className="hidden lg:flex gap-50 font-[500]" justify="center">
        <NavbarItem>
          <Link to={{ pathname: "/", hash: "#solutions" }} className='text-[#24336A] dark:text-white cursor-pointer'>
            <Trans message='Solutions' />
          </Link>
        </NavbarItem>
        <NavbarItem>
          <NavLink to={'/about'} className='text-[#24336A] dark:text-white cursor-pointer' >
            <Trans message='About Us' />
          </NavLink>
        </NavbarItem>
        <div className="relative group">

          <NavbarItem>
            <NavLink to={'/plans'} className='text-[#24336A] dark:text-white cursor-pointer'>
              <Trans message='Pricing' />
            </NavLink>
          </NavbarItem>
          <div className="absolute overflow-hidden left-0 py-5 hidden min-w-[150px] rounded-lg border bg-white dark:bg shadow-lg group-hover:block">
            <Link to={{ pathname: "/plans", hash: "#personalPlans" }} className="block px-10 py-2 text-[#24336A] dark:text-white hover:bg-gray-100 dark:hover:bg-darkBlue">
              <Trans message="Personal Plans"/>
            </Link>
            <Link to={{ pathname: "/plans", hash: "#businessPlans" }} className="block px-10 py-2 text-[#24336A] dark:text-white hover:bg-gray-100 dark:hover:bg-darkBlue">
              <Trans message="Business Plans"/>
            </Link>

          </div>
        </div>
        <NavbarItem>
          <Link className='text-[#24336A] dark:text-white' to="/contact">
            <Trans message='Contact Us' />
          </Link>
        </NavbarItem>
      </NavbarContent>
      <NavbarContent justify="end" className='hidden lg:flex'>
        {/* <NavbarItem className="hidden lg:flex items-center justify-center bg-primary w-[135px] h-[48px] rounded-[12px] py-12 px-24">
          <Link href="#" className='text-white font-[500] text-center'>Login</Link>
        </NavbarItem> */}
        <NavbarItem>
          <button onClick={() => navigate('/register')} className='hover:bg-primary! hover:opacity-100! font-[500] text-center hidden lg:flex items-center justify-center bg-primary w-[135px] h-[48px] rounded-[12px] py-12 px-24 text-white'>
            <Trans message='Sign Up' />
          </button>
        </NavbarItem>
        <NavbarItem>
          <button onClick={() => navigate('/login')} className='hover:bg-primary! hover:opacity-100! font-[500] text-center hidden lg:flex items-center justify-center bg-primary w-[135px] h-[48px] rounded-[12px] py-12 px-24 text-white'>
            <Trans message='Sign in' />
          </button>
        </NavbarItem>
      </NavbarContent>
      <NavbarMenu>
        <NavbarMenuItem className='mt-8 cursor-pointer w-fit' onClick={() => setIsMenuOpen(false)}>
          <Link to={{ pathname: "/", hash: "#solutions" }} className='text-[#24336A] dark:text-white'><Trans message='Solutions' /></Link>
        </NavbarMenuItem>
        <NavbarMenuItem className='mt-8 cursor-pointer w-fit' onClick={() => setIsMenuOpen(false)}>
          <NavLink to={'/about'} className='text-[#24336A] dark:text-white'><Trans message='About Us' /></NavLink>
        </NavbarMenuItem>
        <NavbarMenuItem className='mt-8 cursor-pointer w-fit' onClick={() => setIsMenuOpen(false)}>
          <NavLink to={'/plans'} className='text-[#24336A] dark:text-white'><Trans message='Pricing' /></NavLink>
        </NavbarMenuItem>
        <NavbarMenuItem className='mt-8 cursor-pointer w-fit' onClick={() => { setIsMenuOpen(false); navigate('/contact'); }}>
          <NavLink to={'/contact'} className='text-[#24336A] dark:text-white'><Trans message='Contact Us' /></NavLink>
        </NavbarMenuItem>
        <NavbarMenuItem className='mt-8 cursor-pointer w-fit' onClick={() => { setIsMenuOpen(false); navigate('/register') }}>
          <div className='text-[#24336A] dark:text-white'><Trans message='Sign up' /></div>
        </NavbarMenuItem>
        <NavbarMenuItem className='mt-8 cursor-pointer w-fit' onClick={() => { setIsMenuOpen(false); navigate('/login') }}>
          <div className='text-[#24336A] dark:text-white'><Trans message='Sign in' /></div>
        </NavbarMenuItem>
      </NavbarMenu>
    </Navbar>
  );
}

function Solutions() {

  return (
    <div className='py-80 px-0 lg:px-80' id='solutions'>
      <h1 className='max-w-[764px] text-[#222E57] dark:text-white font-[600] text-[56px] leading-[67.2px] text-center block mx-auto'><span className='text-gradient-pink'><Trans message="Secure"/><span className='text-[#222E57] dark:text-white'>.</span> <Trans message="Scalable"/><span className='text-[#222E57] dark:text-white'>.</span></span> <Trans message="Your Cloud Advantage"/></h1>
      <p className='max-w-[764px] text-[18px] leading-[27px] text-center text-[#888888] block mx-auto mt-32'><Trans message="Secure, scalable, and tailored to empower your endeavors, the cloud offers unparalleled advantages in today's digital landscape. With robust security measures in place."/></p>
      <div className='w-full mt-80'>
        <div className='flex flex-wrap'>
          <div className='md:w-1/2 w-full p-20'>
            <div className='w-full'>
              <img src={shareImg} alt="share dialog image" loading='lazy' className='w-full' />
            </div>
          </div>
          <div className='md:w-1/2 w-full p-20'>
            <div className='w-full text-black dark:text-white h-full flex flex-col'>
              <h3 className='text-[24px] font-[500]'><Trans message="Collaborative Workspaces and Version Control"/></h3>
              <div className='w-full border flex-grow flex flex-col justify-between p-24 rounded-[24px] mt-20'>
                <div>
                  <h4 className='font-[500]'><Trans message="Real-Time Collaboration"/></h4>
                  <p className='opacity-60'><Trans message="Enable seamless collaboration among team members by allowing them to simultaneously edit documents, share feedback, and work together in real-time."/></p>
                </div>
                <div className='mt-20'>
                  <h4 className='font-[500]'><Trans message="Version History and Rollback"/></h4>
                  <p className='opacity-60'><Trans message="Maintain a detailed version history for files, enabling users to track changes, revert to previous versions, and ensure that the latest edits are always accessible."/></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='flex flex-wrap mt-80'>

          <div className='md:w-1/2 w-full p-20'>
            <div className='w-full text-black dark:text-white h-full flex flex-col'>
              <h3 className='text-[24px] font-[500]'><Trans message="Scalable Storage Solutions"/></h3>
              <div className='w-full border flex-grow flex flex-col justify-between p-24 rounded-[24px] mt-20'>
                <div>
                  <h4 className='font-[500]'><Trans message="Flexible Storage Plans"/></h4>
                  <p className='opacity-60'><Trans message="Choose from a range of storage plans to accommodate your specific needs, allowing you to scale your storage requirements as your business evolves."/></p>
                </div>
                <div className='mt-20'>
                  <h4 className='font-[500]'><Trans message="Pay-as-You-Go Model"/></h4>
                  <p className='opacity-60'><Trans message="Benefit from a cost-effective pay-as-you-go pricing model, ensuring you only pay for the storage resources you consume."/></p>
                </div>
              </div>
            </div>
          </div>

          <div className='md:w-1/2 w-full p-20'>
            <div className='w-full'>
              <img src={chartImg} alt="share dialog image" loading='lazy' className='w-full' />
            </div>
          </div>
        </div>
        <div className='flex flex-wrap mt-80'>
          <div className='md:w-1/2 w-full p-20'>
            <div className='w-full'>
              <img src={lineImg} alt="share dialog image" loading='lazy' className='w-full' />
            </div>
          </div>
          <div className='md:w-1/2 w-full p-20'>
  <div className='w-full text-black dark:text-white h-full flex flex-col'>
    <h3 className='text-[24px] font-[500]'><Trans message="Pre-Built Integrations"/></h3>
    <div className='w-full border flex-grow flex flex-col justify-between p-24 rounded-[24px] mt-20'>
      <div>
        <h4 className='font-[500]'><Trans message="Collaboration Tools"/></h4>
        <p className='opacity-60'><Trans message="Seamless integration with platforms like Slack, Microsoft Teams, or Asana for streamlined teamwork and communication."/></p>
      </div>
      <div className='mt-20'>
        <h4 className='font-[500]'><Trans message="Project Management Solutions"/></h4>
        <p className='opacity-60'><Trans message="Integrate with project management tools like Jira or Trello, ensuring a unified workflow for project teams."/></p>
      </div>
    </div>
  </div>
</div>

        </div>
      </div>
    </div>
  );
}

export function Pricing() {
  const [activeBtn, setActiveBtn] = useState(0);
  const [selectedCycle, setSelectedCycle] =
    useState<UpsellBillingCycle>('yearly');
  const [selectedBusinessCycle, setSelectedBusinessCycle] =
    useState<UpsellBillingCycle>('yearly');

  return (
    <div className='flex flex-col w-full items-center p-20 md:p-80 bg-[#FAFAFB] dark:bg'>
  <h1 className='text-[#24336A] dark:text-white font-[600] text-3xl md:text-[56px] md:leading-[67.2px] text-center max-w-[784px]'>
    <Trans message="Choose your Plan. Try it "/>
    <span className='text-gradient-pink'><Trans message="free"/></span>
    <Trans message=" for 7 days."/>
  </h1>
  <p className='text-center font-[500] text-[14px] text-[#888888] mt-24'>
    <Trans message="Simple, transparent pricing that grows with you. Try any plan free for 30 days."/>
  </p>
  <div className='mt-48 w-full' id='personalPlans'>
    <div className='w-full flex items-center justify-center sm:justify-between gap-30 flex-wrap'>
      <h4 className='text-black dark:text-white font-medium text-2xl'><Trans message="Personal Plans"/></h4>
      <div className='bg-[#0154A01A] w-[288px] h-[57px] p-8 rounded-[24px] flex items-center justify-center gap-8'>
        <button className={`header-button ${selectedCycle === 'monthly' ? 'active' : ''}`} onClick={() => setSelectedCycle('monthly')}>
          <Trans message="Monthly billing"/>
        </button>
        <button className={`header-button ${selectedCycle === 'yearly' ? 'active' : ''}`} onClick={() => setSelectedCycle('yearly')}>
          <Trans message="Annual billing"/>
        </button>
      </div>
    </div>

    <div className='w-full mt-24'>
      <PricingTable
        selectedCycle={selectedCycle}
        productLoader="pricingPage"
        filter={true}
        business={false}
      />
    </div>
  </div>

  <div className='mt-56 w-full' id='businessPlans'>
    <div className='w-full flex items-center justify-center sm:justify-between gap-30 flex-wrap'>
      <h4 className='text-black dark:text-white font-medium text-2xl'><Trans message="Business Plans"/></h4>
      <div className='bg-[#0154A01A] w-[288px] h-[57px] p-8 rounded-[24px] flex items-center justify-center gap-8'>
        <button className={`header-button ${selectedBusinessCycle === 'monthly' ? 'active' : ''}`} onClick={() => setSelectedBusinessCycle('monthly')}>
          <Trans message="Monthly billing"/>
        </button>
        <button className={`header-button ${selectedBusinessCycle === 'yearly' ? 'active' : ''}`} onClick={() => setSelectedBusinessCycle('yearly')}>
          <Trans message="Annual billing"/>
        </button>
      </div>
    </div>

    <div className='w-full mt-24'>
      <PricingTable
        selectedCycle={selectedBusinessCycle}
        productLoader="pricingPage"
        filter={true}
        business={true}
      />
    </div>
  </div>
</div>

  );
}

// interface CtaButtonProps extends ButtonProps {
//   item?: MenuItemConfig;
// }
// function CtaButton({item, ...buttonProps}: CtaButtonProps) {
//   if (!item?.label) return null;
//   const Icon = item.icon ? createSvgIconFromTree(item.icon) : undefined;
//   return (
//     <Button
//       elementType={item.type === 'route' ? Link : 'a'}
//       href={item.action}
//       to={item.action}
//       startIcon={Icon ? <Icon /> : undefined}
//       {...buttonProps}
//     >
//       <Trans message={item.label} />
//     </Button>
//   );
// }

// function PrimaryFeatures({content}: ContentProps) {
//   return (
//     <div
//       className="landing-container items-stretch gap-26 md:flex"
//       id="primary-features"
//     >
//       {content?.primaryFeatures?.map((feature, index) => (
//         <div
//           key={index}
//           className="mb-14 flex-1 rounded-2xl px-24 py-36 text-center shadow-[0_10px_30px_rgba(0,0,0,0.08)] md:mb-0"
//           data-testid={`primary-root-${index}`}
//         >
//           <MixedImage
//             className="mx-auto mb-30 h-128"
//             data-testid={`primary-image-${index}`}
//             src={feature.image}
//           />
//           <h2
//             className="my-16 text-lg font-medium"
//             data-testid={`primary-title-${index}`}
//           >
//             <Trans message={feature.title} />
//           </h2>
//           <div
//             className="text-md text-[0.938rem]"
//             data-testid={`primary-subtitle-${index}`}
//           >
//             <Trans message={feature.subtitle} />
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }

// function SecondaryFeatures({content}: ContentProps) {
//   return (
//     <div className="landing-container">
//       {content?.secondaryFeatures?.map((feature, index) => {
//         const isEven = index % 2 === 0;
//         return (
//           <div
//             key={index}
//             data-testid={`secondary-root-${index}`}
//             className={clsx(
//               'mb-14 py-16 md:mb-80 md:flex',
//               isEven && 'flex-row-reverse',
//             )}
//           >
//             <img
//               src={feature.image}
//               className="mr-auto w-580 max-w-full rounded-lg shadow-[0_10px_30px_rgba(0,0,0,0.08)]"
//               data-testid={`secondary-image-${index}`}
//               alt=""
//             />
//             <div className="ml-30 mr-auto max-w-350 pt-30">
//               <small
//                 className="mb-16 text-xs font-medium uppercase tracking-widest text-muted"
//                 data-testid={`secondary-subtitle-${index}`}
//               >
//                 <Trans message={feature.subtitle} />
//               </small>
//               <h3
//                 className="py-16 text-3xl"
//                 data-testid={`secondary-title-${index}`}
//               >
//                 <Trans message={feature.title} />
//               </h3>
//               <div className="h-2 w-50 bg-black/90" />
//               <div
//                 className="my-20 text-[0.938rem]"
//                 data-testid={`secondary-description-${index}`}
//               >
//                 <Trans message={feature.description} />
//               </div>
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// }

// function BottomCta({content}: ContentProps) {
//   return (
//     <div
//       className="relative bg-[#2B2B2B] bg-no-repeat py-70 text-center text-on-primary md:bg-fixed"
//       style={{backgroundImage: `url("${content.footerImage}")`}}
//       data-testid="footerImage"
//     >
//       <h2
//         className="mx-auto max-w-620 text-3xl font-normal"
//         data-testid="footerTitle"
//       >
//         <Trans message={content.footerTitle} />
//       </h2>
//       {content.footerSubtitle && (
//         <p
//           className="mx-auto mt-50 max-w-620 text-2xl font-normal"
//           data-testid="footerSubtitle"
//         >
//           <Trans message={content.footerSubtitle} />
//         </p>
//       )}
//       <CtaButton
//         item={content.actions?.cta3}
//         size="lg"
//         variant="outline"
//         color="paper"
//         className="mt-50 block"
//         data-testid="cta3"
//       />
//     </div>
//   );
// }
